import React from "react";
import { Switch, Route } from "react-router-dom";
import HomePage from "..";

function RouterHomePage() {
    return (
        <Route path="/">
            <Switch>
                <Route path="/" exact>
                    <HomePage />
                </Route>
            </Switch>
        </Route>
    );
}
export default RouterHomePage;
